<template>
    <div class="btn-export-v2" v-click-outside="close">
        <BmvButton
            variant="secondary"
            :icon="'fal fa-file-export'"
            :icon-right="open ? 'fal fa-chevron-up' : 'fal fa-chevron-down'"
            size="sm"
            @click="open = !open"
        >
            <span class="btn-export-v2-label">{{ $t('topbar.export') || 'Export' }}</span>
        </BmvButton>
        <div v-if="open" class="btn-export-v2-menu" role="menu">
            <button type="button" class="btn-export-v2-item" @click="exportAll">
                <i class="fal fa-download"></i>
                <span>{{ $t('post.page.export.all') }}</span>
            </button>
            <button
                v-if="hasFilters"
                type="button"
                class="btn-export-v2-item"
                @click="exportFiltered"
            >
                <i class="fal fa-filter"></i>
                <span>{{ $t('post.page.export.filtered') }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import BmvButton from '@/components/UI/v2/BmvButton.vue'
import { mapActions } from 'vuex'

export default {
    name: 'ButtonExportPostsV2',
    components: { BmvButton },
    directives: {
        'click-outside': {
            bind(el, binding) {
                el._clickOutside = (e) => {
                    if (!el.contains(e.target)) binding.value()
                }
                document.addEventListener('mousedown', el._clickOutside)
            },
            unbind(el) {
                document.removeEventListener('mousedown', el._clickOutside)
            }
        }
    },
    data() {
        return { open: false }
    },
    computed: {
        hasFilters() {
            // Only show "filtered export" when we're on a Posts-like route
            return /\/posts(\/|$|\?)/.test(this.$route.path) || /\/kanban/.test(this.$route.path)
        }
    },
    methods: {
        ...mapActions('post', ['getExportPosts']),
        close() {
            this.open = false
        },
        exportAll() {
            this.close()
            this.runExport({ filters: {} })
        },
        exportFiltered() {
            this.close()
            this.runExport()
        },
        runExport(filter) {
            this.getExportPosts(filter)
                .then((response) => {
                    if (!response || !response.data) return
                    const blob = new Blob([response.data], { type: 'text/csv' })
                    const url = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = url
                    link.download = 'posts.csv'
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                    window.URL.revokeObjectURL(url)
                })
                .catch((e) => this.$store.dispatch('dispatchError', e))
        }
    }
}
</script>

<style scoped>
.btn-export-v2 {
    position: relative;
}

.btn-export-v2-label {
    display: none;
}

@media (min-width: 640px) {
    .btn-export-v2-label {
        display: inline;
    }
}

.btn-export-v2-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    min-width: 220px;
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    box-shadow: var(--v2-shadow-lg);
    padding: 4px;
    z-index: 40;
    font-family: var(--v2-font-sans);
}

.btn-export-v2-item {
    display: flex;
    align-items: center;
    gap: var(--v2-space-3);
    width: 100%;
    padding: 8px var(--v2-space-3);
    border: none;
    background: transparent;
    border-radius: var(--v2-radius-sm);
    color: var(--v2-text-2);
    font-size: var(--v2-text-sm-size);
    text-align: left;
    cursor: pointer;
    font-family: var(--v2-font-sans);
    transition: background var(--v2-transition-fast),
        color var(--v2-transition-fast);
}

.btn-export-v2-item:hover {
    background: var(--v2-primary-soft);
    color: var(--v2-primary);
}

.btn-export-v2-item i {
    width: 18px;
    font-size: 0.9rem;
    flex-shrink: 0;
    color: var(--v2-text-4);
}

.btn-export-v2-item:hover i {
    color: var(--v2-primary);
}
</style>
